// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailP":"P_d2xDetailP__qrBqw"};